export const COUNTRY_MAP: Record<string, string> = {
  CD: 'DR Congo',
  US: 'United States',
  ZA: 'South Africa',
  GB: 'United Kingdom',
  FR: 'France',
  BE: 'Belgium',
  CA: 'Canada',
  CN: 'China',
  DE: 'Germany',
  AU: 'Australia',
  IN: 'India',
  AE: 'UAE',
  KE: 'Kenya',
  NG: 'Nigeria',
  RW: 'Rwanda',
  TZ: 'Tanzania',
  UG: 'Uganda',
  ZM: 'Zambia',
};

export function countryName(code: string): string {
  return COUNTRY_MAP[code] || code;
}
